<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="title" width="1050px">
      <div>
        <el-radio-group v-model="sale_id" size="small" class="sale-options">
          <template>
            <el-radio :label="item.value" border v-for="(item,index) in saleOption" :key="index" class="sale-option">
              {{ index + 1 }}） {{ item.label }}
            </el-radio>
          </template>
        </el-radio-group>
      </div>
      <div>
        <div style="margin-left: 10px;margin-top: 20px">
          <el-tooltip class="item" effect="light" content="勾选后，[钉钉单聊机器人]将给该销售发送一条跟进任务分配的消息通知" placement="top">
            <el-checkbox v-model="is_notify"><i class="el-icon-chat-dot-square"></i>钉钉通知</el-checkbox>
          </el-tooltip>

        </div>
      </div>
      <div style="text-align: center;margin-top: 20px">
        <el-button @click="sale_id=null">重置</el-button>
        <el-button type="primary" @click="handleSet" :disabled="ids.length>0&&sale_id==null">确认分配</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getCustomerRecordSaleOptions, customerRecordSetSale} from "../../api/customerPool";

export default {
  name: "MatchSale",
  inheritAttrs: false,
  props: {
    ids: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      sale_id: null,
      is_notify: true,
      saleOption: []
    }
  },
  computed: {
    title() {
      return `批量分配客户（${this.ids.length}条）的跟进销售`
    },
  },
  methods: {
    onOpen() {
      this.getOptionSales()

    },
    onClose() {

    },
    close() {
      this.$emit('update:visible', false)
    },
    //可选销售
    getOptionSales() {
      getCustomerRecordSaleOptions().then(res => {
        // eslint-disable-next-line no-console
        const data = res.data || {}
        this.saleOption = data.options || [];
      });
    },
    //批量更换销售
    handleSet() {
      let ids = this.ids;
      let sale = this.saleOption.find(val => val.value === this.sale_id)
      let sale_name = sale.label || ''
      let data = {ids: ids, sale_id: this.sale_id, sale_name: sale_name, is_notify: this.is_notify}
      this.$msgbox.confirm(`是否确认设置当前勾选的[${ids.length}]个客户的跟进销售为“${sale_name}”`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调用删除方法
        customerRecordSetSale(data).then((res) => {
          this.msgSuccess(res.message || '未知操作')
          this.close()
        })
      })
    }
  },

}
</script>

<style scoped>
.sale-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.sale-option {
  /*flex: 2;*/
  margin-bottom: 5px;
  width: 160px;
  margin-left: 10px;

}
</style>